export default __webpack_public_path__ + "static/media/Radio.6f2dd8bb.gif";